




















import CheckboxList from './CheckboxList.vue';
import ToggleClassDirective from '@/shared/directives/toggle-class-directive';
import {defineComponent} from "@vue/composition-api";
import {useGetters, useState} from "vuex-composition-helpers";

export default defineComponent({
  name: 'Filters',
  components: {
    CheckboxList
  },
  directives: {
    ToggleClassDirective
  },
  props: {
    extraClass: {type: String}
  },
  methods: {
    selectFilter(filterName: string, filterGroup: string): void {
      this.$store.commit('filter/setActiveFilter', filterName);
      this.$store.commit('filter/setActiveFilterGroup', filterGroup);
    }
  },
  setup: () => {
    const {filterGroups} = useState('filter', ['filterGroups'])
    const {
      filterItemsOfGroup,
      filterGroupTitle,
      filterGroupDisplayNames
    } = useGetters('filter', ['filterItemsOfGroup', 'filterGroupTitle', 'filterGroupDisplayNames'])

    return {
      filterGroups,
      filterItemsOfGroup,
      filterGroupTitle,
      filterGroupDisplayNames
    }
  }
})
